import { useQuery, useQueryClient } from '@tanstack/react-query';
import { demandeursAPI } from '../../services/api';
import { DemandeurListResponse } from '../../types/demandeur';

/**
 * Query hooks for Demandeurs management (server-paginated list + deleted list).
 * Key root 'demandeurs' matches the realtime-invalidation slug, so the list and
 * the shared useDemandeursDropdown refresh together on any change.
 */
export interface DemandeursListParams {
  skip?: number;
  limit?: number;
  search?: string;
  extra?: Record<string, any>;
}

export const demandeursKeys = {
  root: ['demandeurs'] as const,
  list: (p: DemandeursListParams) => ['demandeurs', 'list', p] as const,
  deleted: ['demandeurs', 'deleted'] as const,
};

export function useDemandeursList(params: DemandeursListParams, enabled = true) {
  return useQuery<DemandeurListResponse>({
    queryKey: demandeursKeys.list(params),
    queryFn: () => demandeursAPI.getAll(params.skip, params.limit, params.search, undefined, undefined, params.extra),
    enabled,
    keepPreviousData: true,
  });
}

export function useDeletedDemandeurs(enabled: boolean) {
  return useQuery<DemandeurListResponse>({
    queryKey: demandeursKeys.deleted,
    queryFn: () => demandeursAPI.getDeleted(),
    enabled,
  });
}

export function useInvalidateDemandeurs() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: demandeursKeys.root });
}
